module.exports = __webpack_public_path__ + "img/图片26.f1f21fcf.png";